import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import SupportArticlePanel from "components/SupportArticlePanel/SupportArticlePanel";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { WordTemplateNewSection } from "WordTemplate/WordTemplateNewSection";
import { useLoaderData } from "react-router";
import { SingleSectionRightSideNavigation } from "components/RightSideNavigation/SingeSectionRightSideNavitagion";

const WordTemplateNewApp = () => {
  const viewModel = useLoaderData<server.viewmodel.WordTemplateNewFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          <WordTemplateNewSection
            mainAreaId={viewModel.mainArea}
            displayVisibleToExternal={viewModel.displayVisibleToExternal}
            displayReadyForESign={viewModel.displayReadyForESign}
            displayVisibleBookkeeping={viewModel.displayVisibleBookkeeping}
          />
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <GeneralOptionsPanel
            links={[{
              text: RESX.Buttons.ListView,
              href: viewModel.listUrl,
              visible: true
            }]}
          />
          <SingleSectionRightSideNavigation
            optionMenuGroup={viewModel.availableMergeFields}
          />
          <SupportArticlePanel
            config={viewModel.articlePanelConfig}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout>
}

export default WordTemplateNewApp;